import React, { useEffect, useState } from 'react'
import DeleteConfirm from '../../../sharedComponents/DeleteConfirm';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import useExpense from '../../money/expense/useExpense';
import { Icon, IconButton } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AddEditForm from '../../../sharedComponents/AddEditForm'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const items = [
  {
    title: 'Expense Option Name',
    name: 'option',
    type: 'text',
  },
  {
    title: 'ต้องการ รอบเรือ',
    name: 'haveShipDate',
    type: 'boolean'
  }
];

const initialState = {
  option : '',
  haveShipDate : false
}

const ExpenseOptionSetting = () => {

  const {expenseOptions, error, getExpenseOptions, addExpenseOptions, deleteExpenseOption, editExpenseOption} = useExpense()

  const [mode, setMode] = useState('register')
  const [modalTitle, setModalTitle] = useState('Register Expense Option Information')
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [option, setOption] = useState(initialState)
  const [selectedOption, setSelectedOption] = useState('')
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;
  
    if (type === 'checkbox') {
      // For a checkbox, use the 'checked' property
      setOption(prevOption => ({
        ...prevOption,
        [name]: checked
      }));
    } else {
      // For other inputs, use the 'value' property
      setOption(prevOption => ({
        ...prevOption,
        [name]: value
      }));
    }
  };

  const openForm = async (isEdit,id) => {
    if(isEdit){
      const optionToEdit = expenseOptions.find(w => w.id === id);
      if(optionToEdit) {
        setOption(optionToEdit);
        setModalTitle('Update Option Information');
        setMode('edit');
      }

    }else{
      setOption({})
      setMode('register')
      setModalTitle('Register Option Information')
    }
    setIsFormOpen(true);
  };

  const closeForm = () =>{
    setIsFormOpen(false);
  }

  const openConfirm = async (id) => {
    const optionToDelete = expenseOptions.find(w => w.id === id);
    if(optionToDelete) {
      setSelectedOption(optionToDelete);
      setOption(optionToDelete)
      setIsConfirmOpen(true)
    }
  };

  const closeConfirm = () =>{
    setIsConfirmOpen(false)
  }

  const handleRegisterOption = async () => {
    try {
      console.log(option)
        const returnResult = await addExpenseOptions(option);
        if (returnResult) {
          toast.success('New Expense Option registered successfully!');
          closeForm();
        } else {
          toast.error(error);
        }
    } catch (err) {

    }
  };

  const handleUpdateOption = async () => {
    try {
      await editExpenseOption(option.id, option);
      toast.success('Website updated successfully!');
      closeForm();
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }
  };

  const handleDeleteOption = async () => {
    const response = await deleteExpenseOption(selectedOption.id)
    if(response){
      toast.success("Delete Travel card successfully")
      closeConfirm()
    }else{
      toast.error("Something wrong.")
    }
  }
  useEffect(() => {
    getExpenseOptions()
  }, []);


  const handeLineLogin = () => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL; // Use environment variable for backend URL
    window.location.href = `${backendUrl}/api/line/login`; // Redirect to backend login route
  };

  return (
    <div>
      <button className='btn-success' onClick={handeLineLogin}>
          Line login Test
        </button>
      <h2>
        Expense Option Setting
      </h2>
      <Modal
        isOpen={isConfirmOpen}
        onRequestClose={closeConfirm}
        style={customStyles}
        ariaHideApp={false}
      >
        <DeleteConfirm 
          items={items} 
          data={option} 
          closeConfirm={closeConfirm}
          confirmFunction={handleDeleteOption}
        />
      </Modal>
      <Modal
        isOpen={isFormOpen}
        onRequestClose={closeForm}
        style={customStyles}
        ariaHideApp={false}
      >
        <AddEditForm 
          items={items} 
          name={modalTitle} 
          data={option} 
          mode={mode}
          closeForm={closeForm}
          handleInputChange={handleInputChange}
          handleRegister={handleRegisterOption}
          handleUpdate={handleUpdateOption}
          stateValue={option}
        />
      </Modal>
      <div className='flex justify-end gap-x-4 align-center mt-12 mb-5'>
        <button className='btn-success' onClick={()=> openForm(false, null)}>
          Register
        </button>
      </div>
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
              No
            </th>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
              Options
            </th>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
              ต้องการ รอบเรือ
            </th>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
              
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {expenseOptions && expenseOptions.map((option, index) => {
            return <tr key={option?.id}>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                {index + 1}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{option?.option}</td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 pl-16">{option?.haveShipDate && <Icon><CheckBoxIcon color='success'/></Icon>}</td>
              <td className="relative whitespace-nowrap py-4 pl-3 pr-0 text-right text-sm font-medium ">
                  <div className="flex items-center space-x-3">
                    <IconButton sx={{mr:-2}}>
                      <EditIcon onClick={()=> openForm(true, option.id)} color='success'/>
                    </IconButton>
                    <IconButton>
                      <DeleteIcon onClick={()=> openConfirm(option?.id)} color='error'/>
                    </IconButton>
                  </div>
              </td>
            </tr>
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ExpenseOptionSetting